import React, { useState, useEffect } from 'react';
import { Button, Table, Drawer, Form, Input, Select, Radio, message, Checkbox, Spin, Modal, Col, Row, Tag } from "antd";
import { PlusOutlined, ArrowLeftOutlined, CheckOutlined } from "@ant-design/icons";
import '../assets/styles/common.css';
import { metaDataGroupManage, checkFieldExistsInWorkflowMetadata } from '../../../services/admin/adminService';
import Grid from "../components/CommonFields/Grid";

const { Option } = Select;
const GROUPTYPE_DEFAULT = 0;
const GROUPTYPE_GLOBAL = 1;
const defaultIndexSelectValues = ["key_1", "key_2", "key_3"];

const MetadataFields = ({ group, goBack, openDrawer = false, allGroups = [], onSaveGroup }) => {
    const { groupName, configData } = group;
    const [fieldsData, setFieldsData] = useState(configData?.Fields || []);
    const [isDrawerVisible, setIsDrawerVisible] = useState(openDrawer);
    const [editRecordKey, setEditRecordKey] = useState(null);
    const [groupNameInput, setGroupNameInput] = useState(group?.groupName || "");
    const [groupType, setGroupType] = useState(group?.groupType === GROUPTYPE_GLOBAL ? GROUPTYPE_GLOBAL : GROUPTYPE_DEFAULT);
    const [description, setDescription] = useState(group?.description || "");
    const [loading, setLoading] = useState(false);

    //Add Index and Unique Node in field object from Group json Node
    // const updateFieldsObject = (inputJson) => {
    //     debugger;
    //     const indexesReverseMap = Object.entries(inputJson.Indexes).reduce((acc, [key, value]) => {
    //         acc[value] = key;
    //         return acc;
    //     }, {});

    //     // Update Fields with Unique and Index if matched
    //     const updatedFields = inputJson.Fields.map(field => {
    //         if (inputJson.Unique.includes(field.Name)) {
    //             field.Unique = true;
    //         }

    //         if (indexesReverseMap[field.Name]) {
    //             field.Index = indexesReverseMap[field.Name];
    //         }
    //         return field;
    //     });
    //     setFieldsData(updatedFields);
    // } 

    const [form] = Form.useForm();
    useEffect(() => {
        if (openDrawer) {
            setIsDrawerVisible(true);
            form.resetFields();
        }
    }, [openDrawer, form]);

    const handleEditClick = (field) => {
        // const isUnique = group?.configData?.Unique?.includes(field.Name);
        // const fieldIndex = Object.entries(group?.configData?.Indexes || {}).find(([key, value]) => value === field.Name)?.[0] || "";
        const isUnique = field.Unique;
        const fieldIndex = field.Index;
        setEditRecordKey(field.Name);
        form.setFieldsValue({
            ...field,
            Index: fieldIndex || "",
            Unique: isUnique || false,
            HashRequired: field?.HashRequired === "Yes" ? "Yes" : "No",
            IsSecured: field?.IsSecured === "Yes" ? "Yes" : "No",
            HashPositions: field?.HashPositions === "Yes" ? "Yes" : "No",
        });

        setIsDrawerVisible(true);
    };

    const handleAddClick = async () => {
        try {
            if (!group?.groupId) {
                await form.validateFields(["GroupName"]);
            }

            setEditRecordKey(null);
            form.resetFields(["Name", "Value", "DataType", "Index", "Unique", "HashRequired", "HashPositions", "IsSecured"]);

            setIsDrawerVisible(true);
        } catch (error) {
            console.warn("Group Name validation failed:", error);
        }
    };

    const closeDrawer = () => {
        setIsDrawerVisible(false);
    };

    const handleDelete = (field) => {
        if (!field?.Name) {
            message.error("Invalid field selected for deletion.");
            return;
        }

        const filteredFields = fieldsData.filter(f => f.Name.toLowerCase() !== field.Name.toLowerCase());
        setFieldsData(filteredFields);
        message.success("Field deleted successfully!");
    };

    const columns = [
        {
            title: "Field Name",
            dataIndex: "Name",
            key: "Name",
        },
        {
            title: "Field Index",
            dataIndex: "Index",
            key: "Index",
            width: 100,
            tag: true,
            tagColor: "#f9a11b",
        },
        {
            title: "Unique",
            dataIndex: "Unique",
            key: "Unique",
            width: 100,
            tag: true,
            tagColor: "#0e8617",
            boolean: true, //consider the 1 or 0 is true or false to set 'tag' if it is 'true'
        },
        {
            title: 'Actions',
            key: 'actions',
            dataIndex: 'actions',
            width: 100,
            fixed: 'right',
            render: ['edit', 'delete']
        },
    ];

    const handleDrawerAddField = async () => {
        try {
            const values = await form.validateFields();

            if (values.Name.trim() !== "") {
                const groupId = group?.groupId;
                const resObj = await checkFieldExistsInWorkflowMetadata(groupId, values.Name);
                //console.log("resObj:", resObj);
                if (resObj?.data?.success) {
                    const isExist = resObj?.data?.data?.fieldsExists;
                    const resultArray = JSON.parse(isExist?.result);
                    if (resultArray?.length == 0) {
                        const fieldToAdd = {
                            ...values,
                            Name: values.Name.trim()
                        };
                        let updatedFields;
                        if (editRecordKey) {
                            updatedFields = fieldsData.map(field =>
                                field.Name === editRecordKey ? { ...field, ...fieldToAdd } : field
                            );
                        } else {
                            updatedFields = [...fieldsData, fieldToAdd];
                        }
                        setFieldsData(updatedFields);
                        setIsDrawerVisible(false);
                        message.success(editRecordKey ? "Field updated!" : "Field added!");
                    }
                    else {
                        message.error("The field name is already in use in a group that's part of an active workflow.");
                    }
                }
                else {
                    message.error("Error in Field Name exists check");
                }
            }
            else {
                message.error("Field Name should not be empty");
            }

        } catch (error) {
            console.error("Error adding/updating field:", error);
            message.error("Please fill all required field data.");
        }
    };

    const handleSaveGroup = async () => {
        try {
            if (!group?.groupId) {
                await form.validateFields(["GroupName"]);
            }
            setLoading(true);
            const trimmedGroupNameInput = groupNameInput.trim();
            const trimmedDescription = description.trim();
            const Indexes = {};
            const uniqueFields = [];

            fieldsData.forEach((field) => {
                // if (field.Index) {
                //     Indexes[field.Index] = field.Name;
                // }
                // if (field.Unique === true) {
                //     uniqueFields.push(field.Name);
                // }
                if (field.Index) {
                    for (const key in Indexes) {
                        if (Indexes[key] === field.Name) {
                            delete Indexes[key];
                        }
                    }
                    Indexes[field.Index] = field.Name;
                }
                if (field.Unique === true) {
                    const index = uniqueFields.indexOf(field.Name);
                    if (index !== -1) {
                        uniqueFields.splice(index, 1);
                    }
                    uniqueFields.push(field.Name);
                }
            });

            const transformedFields = fieldsData.map((field) => ({
                Name: field.Name,
                Value: field.Value || "",
                DataType: field.DataType,
                HashRequired: field.HashRequired || "No",
                HashPositions: field.HashPositions || "",
                IsSecured: field.IsSecured || "No",
                Index: field.Index || "",
                Unique: field.Unique || false,
            }));

            const updatedConfigData = {
                GroupName: trimmedGroupNameInput,
                Unique: uniqueFields,
                Indexes: Indexes,
                Fields: transformedFields
            };

            const payload = {
                groupId: group?.groupId || "",
                groupName: trimmedGroupNameInput,
                groupType: groupType,
                actionType: group?.groupId ? "update" : "add",
                fieldConfigData: JSON.stringify(updatedConfigData),
                groupDesc: trimmedDescription,
            };

            const response = await metaDataGroupManage(payload);

            if (response?.success) {
                if (response?.data?.group?.[0].groupId) {
                    const isExistsGroupName = response?.data?.group?.[0].isExists;
                    if (isExistsGroupName === 'false') {
                        const newGroupId = response?.data?.group?.[0].groupId;
                        const updatedGroup = {
                            ...group,
                            groupId: newGroupId,
                            groupName: groupNameInput,
                            description: description
                        };
                        onSaveGroup(updatedGroup);
                        message.success(`Group ${group?.groupId ? 'updated' : 'saved'} successfully!`);
                    }
                    else {
                        message.error('Group Name already Exists');
                    }
                }
            } else {
                message.error("Failed to save group.");
            }

        } catch (error) {
            console.error("Error saving group:", error);
            message.error("An error occurred while saving the group.");
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (group?.groupName) {
            form.setFieldsValue({
                GroupName: group.groupName,
                Description: group.description
            });
        } else {
            console.log("GroupName is undefined or empty");
        }
    }, [group, form]);

    return (
        <>
            <div>
                <h2>{groupName}</h2>
                <Form
                    form={form}
                    layout="vertical"
                    style={{ width: "100%" }}
                    initialValues={{
                        GroupType: groupType === GROUPTYPE_GLOBAL, // Must be boolean for checkbox
                    }}
                >
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={12} lg={5}>
                            <Form.Item
                                label="Group Name"
                                name="GroupName"
                                rules={[
                                    { required: true, message: "Field is required" },
                                    () => ({
                                        validator(_, value) {
                                            const trimmedValue = value?.trim().toLowerCase();
                                            const isDuplicate = allGroups.some(
                                                (g) =>
                                                    g.groupName.trim().toLowerCase() === trimmedValue &&
                                                    g.groupId !== group?.groupId
                                            );
                                            if (isDuplicate) {
                                                return Promise.reject(new Error("Group name already exists."));
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <Input
                                    placeholder="Group Name"
                                    value={groupNameInput}
                                    onChange={(e) => setGroupNameInput(e.target.value)}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={12} lg={5}>
                            <Form.Item label="Description" name="Description">
                                <Input placeholder="Description"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={7}>
                            <Form.Item label="Global Group" name="GroupType" valuePropName="checked">
                                <Checkbox onChange={(e) => setGroupType(e.target.checked ? GROUPTYPE_GLOBAL : GROUPTYPE_DEFAULT)} />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={12} lg={2}>
                            <Form.Item label=" ">
                                <Button
                                    icon={<ArrowLeftOutlined />}
                                    onClick={goBack}
                                    style={{ width: '100%' }}
                                >
                                    Back
                                </Button>
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={12} lg={4}>
                            <Form.Item label=" ">
                                <Button
                                    type="primary"
                                    icon={<CheckOutlined />}
                                    onClick={handleSaveGroup}
                                    style={{ width: '100%', color: 'white' }}
                                    disabled={!groupNameInput || fieldsData.length === 0}
                                >
                                    {group?.groupId ? "Update Group" : "Save Group"}
                                </Button>
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>

                <Spin spinning={loading}>
                    <Grid
                        columnData={{ columns: columns }}
                        tableData={fieldsData}
                        // loading={loading}
                        rowKey="Name"
                        searchButton={true}
                        downloadCSV={true}
                        showEdit={true}
                        showDelete={true}
                        csvFileName="ClientDataGroup"
                        paginationConfig={{ pageSizeOptions: ['10', '20', '50', '100'] }}
                        className="custom-grid"
                        handleEdit={handleEditClick}
                        handleDelete={handleDelete}
                        createButton={true}
                        createButtonName={'Add Fields'}
                        createButtonIcon={<CheckOutlined />}
                        handleCreate={handleAddClick}
                    />
                </Spin>
                <Drawer
                    title={editRecordKey ? "Edit Field" : "Add Field"}
                    style={{ width: '25%' }}
                    open={isDrawerVisible}
                    onClose={closeDrawer}
                    className="custom-drawers cus-drawer-sm"
                    footer={
                        <div style={{ textAlign: 'right' }}>
                            <Button onClick={closeDrawer} style={{ marginRight: 8 }}>
                                Cancel
                            </Button>
                            <Button onClick={handleDrawerAddField} type="primary">
                                {editRecordKey ? 'Update Field' : 'Add Field'}
                            </Button>
                        </div>
                    }
                >
                    <Form form={form} layout="vertical">
                        <Form.Item
                            label="Field Name"
                            name="Name"
                            // rules={[
                            //     { required: true, message: "Field is required" },
                            //     ({ getFieldValue }) => ({
                            //         validator(_, value) {
                            //             const trimmedName = value?.trim();
                            //             const isDuplicate = fieldsData.some(
                            //                 field => field.Name.toLowerCase() === trimmedName?.toLowerCase() &&
                            //                     field.Name !== editRecordKey // Allow the same name during edit
                            //             );
                            //             if (isDuplicate) {
                            //                 return Promise.reject(new Error("Field Name already exists"));
                            //             }
                            //             return Promise.resolve();
                            //         }
                            //     })
                            // ]}
                            rules={[
                                { required: true, message: "Field is required" },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        const trimmedName = value?.trim();

                                        if (/\s/.test(trimmedName)) {
                                            return Promise.reject(new Error("Spaces are not allowed"));
                                        }

                                        if (/[^a-zA-Z0-9_]/.test(trimmedName)) {
                                            return Promise.reject(new Error("Only letters, numbers, and underscores are allowed"));
                                        }

                                        const isDuplicate = fieldsData.some(
                                            field => field.Name.toLowerCase() === trimmedName?.toLowerCase() &&
                                                field.Name !== editRecordKey // Allow same name during edit
                                        );
                                        if (isDuplicate) {
                                            return Promise.reject(new Error("Field Name already exists"));
                                        }

                                        return Promise.resolve();
                                    }
                                })
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item label="Data Type" name="DataType" rules={[{ required: true, message: "Field is required" }]}>
                            <Select>
                                <Option value="Text">Text</Option>
                                <Option value="Number">Number</Option>
                                <Option value="Boolean">Boolean</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="Index"
                            name="Index"
                            rules={[
                                { required: false, message: "Field is required" },
                                // ({ getFieldValue }) => ({
                                //     validator(_, value) {
                                //         if (!value) return Promise.resolve();
                                //         const isDuplicate = fieldsData.some(field => {
                                //             const existingIndex = Object.entries(group?.configData?.Indexes || {}).find(
                                //                 ([key, val]) => key === value && field.Name !== editRecordKey && val === field.Name
                                //             );
                                //             return !!existingIndex;
                                //         });

                                //         if (isDuplicate) {
                                //             return Promise.reject(new Error(`Index is already used in another field.`));
                                //         }

                                //         return Promise.resolve();
                                //     }
                                // })
                            ]}
                        >
                            {/* <Select>
                                <Option value="">Select</Option>
                                <Option value="key_1">Key 1</Option>
                                <Option value="key_2">Key 2</Option>
                                <Option value="key_3">Key 3</Option>
                            </Select> */}
                            <Select>
                                <Option value="">Select</Option>
                                {defaultIndexSelectValues.map((key) => {
                                    const isUsedByAnotherField = fieldsData.some(
                                        (field) => field.Index === key && field.Name !== editRecordKey
                                    );
                                    return (
                                        <Option key={key} value={key} disabled={isUsedByAnotherField}>
                                            {key.replace("_", " ").toUpperCase()}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </Form.Item>
                        <Form.Item label="Default Value" name="Value">
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Unique"
                            name="Unique"
                            valuePropName="checked"
                            rules={[
                                {
                                    validator: (_, value) => {
                                        // Only validate if "Unique" is checked
                                        if (value) {
                                            const isDuplicateUnique = fieldsData.some(
                                                field =>
                                                    field.Unique === true &&
                                                    field.Name !== editRecordKey // Allow during edit
                                            );

                                            if (isDuplicateUnique) {
                                                return Promise.reject(
                                                    new Error("A field with Unique is already associated")
                                                );
                                            }
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Checkbox>Is Unique</Checkbox>
                        </Form.Item>


                        <Form.Item label="Hash Required" name="HashRequired">
                            <Radio.Group defaultValue="No">
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item label="Hash Positions" name="HashPositions">
                            <Radio.Group defaultValue="No">
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item label="Is Secured" name="IsSecured">
                            <Radio.Group defaultValue="No">
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Form>
                </Drawer>
            </div>

        </>
    );
};

export default MetadataFields;